<div class="modal fade instructor-modal" id="appModal" #appModal tabindex="-1" role="dialog">
    <div class="modal-dialog">
        <div class="modal-content location-save-text">
            <div class="modal-body">
                <div class="modal-header">
                    {{ 'CalendarEvent.SelectInstructorTitle' | translate}}
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="container-fluid mt-2 p-0 location-form">
                    <div><span translate>CalendarEvent.SelectNewInstructor</span></div>
                    <app-instructor-search-component id="instructor-search" class="control-height"
                        (instructorSelected)="onInstructorSelectedSelected($event)" [clubIds]="clubId | singleItemArray"
                        [selectedInstructorModel]="selectedInstructorModel" [dropDownWidth]="500">
                    </app-instructor-search-component>

                    <div class="row mt-3">
                        <div class="col text-center mx-3 buttons-row">
                            <button class="btn bc-button mr-2 mt-3" (click)="onClose()"
                                translate>CalendarEvent.CancelInstructor</button>
                            <button class="btn btn-success ml-2 mt-3" (click)="onSave()"
                                translate>CalendarEvent.SaveInstructor</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
